// import About from '@components/AboutUs';
import AboutUs from 'pages/gioi-thieu-tnh';
import ConfigService from '@services/config.service';
import AppConfigService from '@services/app-config.service';
import {getSeoOnPage} from '@helper/seo/seo';

export default function AboutPage(props) {
    return <AboutUs {...props} />;
}

export async function getServerSideProps(context) {
    const {locale} = context;
    const urlStatic = context.resolvedUrl.replace('/', '');
    const _configService = new ConfigService(context);

    let seoPage = null;
    try {
        const appConfigService = new AppConfigService(context);
        const seoConfig = await appConfigService.getAppConfig({page: 'SEO'});
        seoPage = getSeoOnPage('GIOITHIEU', seoConfig);
        const webUrl = process.env.NEXT_PUBLIC_WEB_URL || 'https://tnh.com.vn';
        seoPage.canonical = `${webUrl}/gioi-thieu`;
        if (seoPage.openGraph) {
            seoPage.openGraph.url = `${webUrl}/gioi-thieu`;
        }
    } catch (error) {
        console.error('Failed to fetch SEO for about page:', error);
    }

    try {
        //let _dataStatic = await _configService.getStaticContent({urlStatic, locale});
        let _dataStatic = ''; //JSON.parse(JSON.stringify(_dataStatic));""
        //let _dataContact = await _configService.getContact();
        let _dataContact = ''; //JSON.parse(JSON.stringify(_dataContact));""

        return {
            props: {
                _dataStatic,
                _dataContact,
                seoPage,
            },
        };
    } catch (error) {
        return {
            props: {
                _dataStatic: '',
                _dataContact: '',
                seoPage,
            },
        };
    }
}
